import { CSSProperties } from 'react';
import {
    AssignmentOutlined as AssignmentIcon,
    CallSplitOutlined as CallSplitIcon,
    DescriptionOutlined as DescriptionIcon,
    FavoriteBorderOutlined as FavoriteBorderIcon,
    FeedbackOutlined as FeedbackIcon,
    NewReleasesOutlined as NewReleasesIcon,
    PeopleOutlined as PeopleIcon,
    PersonAddOutlined as PersonAddIcon,
    ReportProblemOutlined as ReportProblemIcon,
    SpeakerNotesOutlined as SpeakerNotesIcon,
    StarBorderOutlined as StarBorderIcon,
    SystemUpdateOutlined as SystemUpdateIcon,
    CalendarToday as CalendarTodayIcon,
    AccountBalance as AccountBalanceIcon,
    Public as PublicIcon,
    Business as BusinessIcon,
    HomeWork as HomeWorkIcon,
    Group as GroupIcon,
    GroupWork as GroupWorkIcon,
    SupervisedUserCircle as SupervisedIcon,
    Toc as TocIcon,
    RecentActors as RecentActorsIcon,
    SettingsInputComponent as SettingsInputIcon,
    PersonAdd as PersonAddNormalIcon,
    LocalPrintshop,
    SupervisedUserCircleOutlined,
} from '@material-ui/icons';

import { RiVirusLine } from 'react-icons/ri';
import React from 'react';
import SynergyIcon from 'src/images/Synergy';

const iconStyle: CSSProperties = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: '40px',
    opacity: '0.9',
    color: 'white',
};

export const giveAppsIcons = (status: number) => {
    switch (true) {
        case status === 1:
            return <StarBorderIcon style={iconStyle} />;
        case status === 2:
            return <ReportProblemIcon style={iconStyle} />;
        case status === 3:
            return <AssignmentIcon style={iconStyle} />;
        case status === 4:
            return <SpeakerNotesIcon style={iconStyle} />;
        case status === 5:
            return <RiVirusLine style={iconStyle} />;
        case status === 6:
            return <SystemUpdateIcon style={iconStyle} />;
        case status === 7:
            return <PersonAddIcon style={iconStyle} />;
        case status === 8:
            return <DescriptionIcon style={iconStyle} />;
        case status === 9:
            return <DescriptionIcon style={iconStyle} />;
        case status === 10:
            return <SynergyIcon />;
        case status === 11:
            return <FeedbackIcon />;
        case status === 12:
            return <StarBorderIcon />;
        case status === 13:
            return <NewReleasesIcon />;
        case status === 14:
            return <CallSplitIcon />;
        case status === 15:
            return <FavoriteBorderIcon />;
        case status === 16:
            return <PeopleIcon />;
        case status === 17:
            return <CalendarTodayIcon />;
        case status === 18:
            return <AccountBalanceIcon />;
        case status === 19:
            return <PublicIcon />;
        case status === 20:
            return <BusinessIcon />;
        case status === 21:
            return <HomeWorkIcon />;
        case status === 22:
            return <GroupWorkIcon />;
        case status === 23:
            return <GroupIcon />;
        case status === 24:
            return <SupervisedIcon />;
        case status === 25:
            return <TocIcon />;
        case status === 26:
            return <RecentActorsIcon />;
        case status === 27:
            return <SettingsInputIcon />;
        case status === 28:
            return <PersonAddNormalIcon />;
        case status === 29:
            return <StarBorderIcon />;
        case status === 30:
            return <FeedbackIcon />;
        case status === 31:
            return <FeedbackIcon />;
        case status === 32:
            return <StarBorderIcon />;
        case status === 33:
            return <LocalPrintshop />;
        case status === 34:
            return <SupervisedUserCircleOutlined style={iconStyle} />;
        default:
            break;
    }
};
